/**
 * Push Notification API Service
 */

import apiClient from '../apiClient';
import { ENDPOINTS } from '../endpoints';

export const getVapidPublicKey = async () => {
  const response = await apiClient.get(ENDPOINTS.PUSH.VAPID_KEY);
  return response?.data?.data?.publicKey || '';
};

export const subscribePush = (payload) =>
  apiClient.post(ENDPOINTS.PUSH.SUBSCRIBE, payload);

export const unsubscribePush = (endpoint) => {
  const params = endpoint ? { params: { endpoint } } : undefined;
  return apiClient.delete(ENDPOINTS.PUSH.UNSUBSCRIBE, params);
};

